import { MappedClass, MappedProperty } from '@h5s/util-object';
import { CashRegister } from './cash-register';
import { DeviceType } from './device-type';

@MappedClass()
export class UpdateCashRegister {
  @MappedProperty()
  id: number;

  @MappedProperty()
  ownerCorporateDataId: number | null;

  @MappedProperty()
  description: string | null;

  @MappedProperty()
  cashRegisterType: DeviceType | null;

  @MappedProperty()
  address: string | null;

  @MappedProperty()
  port: string | null;

  @MappedProperty()
  username: string | null;

  @MappedProperty()
  localAddress: string | null;

  @MappedProperty()
  invoiceBlocks: string[] | null;

  @MappedProperty()
  doubleCopy: boolean | null;

  public toUpdateCashRegister(cashRegister: CashRegister): void {
    this.id = cashRegister.id ?? null;
    this.ownerCorporateDataId = cashRegister.ownerCorporateDataId ?? null;
    this.description = cashRegister.description ?? null;
    this.address = cashRegister.address ?? null;
    this.port = cashRegister.port ?? null;
    this.username = cashRegister.username ?? null;
    this.localAddress = cashRegister.localAddress ?? null;
    this.invoiceBlocks = cashRegister.invoiceBlocks ?? null;
    this.doubleCopy = cashRegister.doubleCopy ?? null;
    this.cashRegisterType = cashRegister.cashRegisterType?.type ?? null;
  }
}
